import React from 'react'
import { Box, Text } from 'grommet'

const LabelIcon = ({ name, size, color }) => {
  return (
    <Box
      round=".3rem"
      border={{ side: 'all', color: color, size: '1px', style: 'solid' }}
      width={size}
      height={size}
      align="center"
      justify="center"
    >
      <Text size="1.3rem" color={color}>
        {name}
      </Text>
    </Box>
  )
}

export default LabelIcon
